import AppHeader from '../AppHeader'
export default {
  name: 'will-must-list',
  components: {
    AppHeader
  },
  created () {
    let param = {
      'user_id': window.localStorage.getItem('user_id')
    }
    this.$store.dispatch('GET_ALL_WILL_MUST', {data: param, callback: this.set})
  },
  data () {
    return {
      willMustList: [],
      callbackFlag: false
    }
  },
  computed: {
    willMustListData () {
      return this.$store.getters.willMustList
    }
  },
  methods: {
    goTop: function () {
      this.$router.push({path: '/'})
    },
    goDetail: function (date) {
      let target = date.replace(/(\d+)-(\d+)-(\d+)/, '$1-$2-$3')
      this.$router.push({path: '/will_must/' + target})
    },
    formatDate: function (date) {
      return date.replace(/(\d+)-0?(\d+)-(\d+)/, '$1年$2月')
    },
    set: function () {
      if (this.willMustListData) {
        for (let key in this.willMustListData) {
          let date = this.willMustListData[key]['will_must_date']
          let will = this.willMustListData[key]['will_content']
          let must = this.willMustListData[key]['must_content']
          let reflect = this.willMustListData[key]['reflect_content']
          let evaluation = this.willMustListData[key]['evaluation']
          if (will !== null && must !== null && reflect !== null && evaluation !== null) {
            this.willMustList.push(date)
          }
        }
      }
      this.callbackFlag = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/will-must-list.js